
import React, { Component, createRef } from 'react';
import axios from 'axios';
import { getApiHeaderGuest } from '../../../../utils/CommonFunctions';
import "react-addressfinder/dist/widget.css";
import { WidgetInput } from "react-addressfinder";
import swal from 'sweetalert';
import whiteLOgo from "../../../../assets/img/logo-white-small.png";
import SignatureCanvas from 'react-signature-canvas';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;

const AddressFinder = ({ addressFinderKey, inputClassName, id, onChange }) => {
  return (
    <WidgetInput
      addressFinderKey={addressFinderKey}
      inputClassName={inputClassName}
      id={id}
      onSelected={(fullAddress, address) => {
        onChange(fullAddress, address);
      }}
    />
  );
};

class Consent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        agreeToTerms: false,
        agreeToPrivacy: false,
        signature: '',
        activation_id: "",
        paramName: '',
        paramValue: '',
        address: "",
        password: "",
        c_password: "",
        addres_prop: "",
      },
      errors: {},
      isSubmitting: false,
      hasSignature: false,
      signatureData: null, // Store signature stroke data
      customer_details: "",
      payment_details: "",
      addressedit: 0,
      common_data: "",
    };

    this.signatureRef = createRef();
    this.cleanupViewportListeners = null; // Store cleanup function
  }

  Editaddress = (event) => {
    this.setState({ addressedit: 1 });
  };

  Canceladdress = (event) => {
    this.setState({ addressedit: 0 });
  };

  setaddressFinder = async (full_address, address) => {
   


    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        address: full_address
      },
      errors: {
        ...prevState.errors,
        address: ''
      }
    }));

    this.Canceladdress();
  };

  // Add viewport listeners for mobile signature preservation
  addViewportListeners = () => {
    let timeoutId;
    const handleViewportChange = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        if (this.signatureRef.current && this.state.signatureData) {
          // Restore signature after viewport stabilizes
          try {
            this.signatureRef.current.fromData(this.state.signatureData);
          } catch (error) {
            console.warn('Failed to restore signature:', error);
          }
        }
      }, 300); // Wait for viewport to stabilize
    };

    window.addEventListener('resize', handleViewportChange);
    window.addEventListener('orientationchange', handleViewportChange);
    
    // Store cleanup function
    this.cleanupViewportListeners = () => {
      window.removeEventListener('resize', handleViewportChange);
      window.removeEventListener('orientationchange', handleViewportChange);
      clearTimeout(timeoutId);
    };

    // Enhanced iOS Safari detection and handling
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || 
                  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    
    if (isIOS) {
      let initialViewportHeight = window.innerHeight;
      let keyboardDetectionTimeout;
      
      const handleIOSViewportChange = () => {
        clearTimeout(keyboardDetectionTimeout);
        
        keyboardDetectionTimeout = setTimeout(() => {
          const currentViewportHeight = window.innerHeight;
          const heightDifference = initialViewportHeight - currentViewportHeight;
          
          // If height decreased significantly, keyboard is likely open
          if (heightDifference > 150) {
            // Keyboard opened - preserve current signature
            if (this.signatureRef.current && !this.signatureRef.current.isEmpty()) {
              try {
                const currentSignatureData = this.signatureRef.current.toData();
                this.setState({ signatureData: currentSignatureData });
              } catch (error) {
                console.warn('Failed to save signature data:', error);
              }
            }
          } else if (heightDifference < 50) {
            // Keyboard closed - restore signature after a delay
            setTimeout(() => {
              if (this.signatureRef.current && this.state.signatureData) {
                try {
                  this.signatureRef.current.fromData(this.state.signatureData);
                } catch (error) {
                  console.warn('Failed to restore signature on iOS:', error);
                }
              }
            }, 200);
          }
        }, 100);
      };
      
      window.addEventListener('resize', handleIOSViewportChange);
      
      // Update cleanup function to include iOS listeners
      const originalCleanup = this.cleanupViewportListeners;
      this.cleanupViewportListeners = () => {
        originalCleanup();
        window.removeEventListener('resize', handleIOSViewportChange);
        clearTimeout(keyboardDetectionTimeout);
      };
    }
  };

  componentDidMount() {
    const customerAddress = this.props.customer_details.address;

    if (customerAddress) {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          address: customerAddress
        }
      }));
    }






    if (process.env.REACT_APP_ENV == "uat") {
      if (customerAddress) {
        this.setState(prevState => ({
          formData: {
            ...prevState.formData,
            address: customerAddress
          }
        }));
      } else {
        this.setState(prevState => ({
          formData: {
            ...prevState.formData,
            address: "14 FERN STREET, NARACOORTE SA 5271"
          }
        }));
      }
    }

    const searchParams = new URLSearchParams(window.location.search);
    const iterator = searchParams.entries().next();
    if (!iterator.done) {
      const [paramName, paramValue] = iterator.value;
      this.setState({
        paramName,
        paramValue
      });
    }

    // Handle signature canvas sizing and restoration after mount
    setTimeout(() => {
      if (this.signatureRef.current) {
        const canvas = this.signatureRef.current.getCanvas();
        canvas.style.width = '100%';
        canvas.style.height = '150px';
        
        // Restore signature if it exists
        if (this.state.signatureData) {
          try {
            this.signatureRef.current.fromData(this.state.signatureData);
          } catch (error) {
            console.warn('Failed to restore signature on mount:', error);
          }
        }
      }
    }, 100);

    // Add viewport change listeners for mobile
    this.addViewportListeners();
  }

  componentWillUnmount() {
    // Cleanup event listeners to prevent memory leaks
    if (this.cleanupViewportListeners) {
      this.cleanupViewportListeners();
    }
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === 'checkbox' ? checked : value;
    
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: inputValue
      },
      errors: {
        ...prevState.errors,
        [name]: ''
      }
    }));
  };

  validateForm = () => {
    const { formData, hasSignature } = this.state;
    const { customer_details } = this.props;
    const errors = {};

    if (!formData.activation_id || formData.activation_id.trim() === '') {
      errors.activation_id = 'Activation Code is required';
    }

    if (!customer_details?.myaccount_exist && (!formData.password || formData.password.trim() === '')) {
      errors.password = 'Password is required';
    }


    if (!customer_details?.myaccount_exist && formData.password.trim().length <= 6) {
       errors.password = 'Password must be greater than 6 characters';
    }

    if (!customer_details?.myaccount_exist && (!formData.c_password || formData.c_password.trim() === '')) {
      errors.c_password = 'Password Confirmation is required';
    }


    if (!customer_details?.myaccount_exist && (formData.password && formData.c_password)) {
      if(formData.password != formData.c_password){
         errors.c_password = 'Confirmation password is not matched';
      }
    }



    if (!formData.agreeToTerms) {
      errors.agreeToTerms = 'You must agree to terms and conditions';
    }

    if (!formData.agreeToPrivacy) {
      errors.agreeToPrivacy = 'You must agree to critical Information Summary';
    }

    if (!hasSignature) {
      errors.signature = 'Please provide your signature';
    }

    if (!formData.address) {
      errors.address = 'Address is required';
    }
    
    


    return errors;
  };

  // Function to compress/resize signature image
  compressSignatureImage = (canvas) => {
    // Check if canvas is empty first
    if (this.signatureRef.current.isEmpty()) {
      return null;
    }
  
    // Create a temporary canvas with the same dimensions initially
    const tempCanvas = document.createElement('canvas');
    const tempCtx = tempCanvas.getContext('2d');
    
    // Set the same dimensions as original to preserve quality
    tempCanvas.width = canvas.width;
    tempCanvas.height = canvas.height;
    
    // Set white background explicitly
    tempCtx.fillStyle = 'white';
    tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
    
    // Draw the signature on top of white background
    tempCtx.drawImage(canvas, 0, 0);
    
    // Return as PNG with good quality (PNG preserves transparency better than JPEG)
    return tempCanvas.toDataURL('image/png', 0.9);
  };
  
  // Alternative method - Get signature without compression (recommended)
  getSignatureImage = () => {
    if (this.signatureRef.current.isEmpty()) {
      return null;
    }
    
    const canvas = this.signatureRef.current.getCanvas();
    const ctx = canvas.getContext('2d');
    
    // Create a new canvas with white background
    const newCanvas = document.createElement('canvas');
    const newCtx = newCanvas.getContext('2d');
    
    newCanvas.width = canvas.width;
    newCanvas.height = canvas.height;
    
    // Fill with white background
    newCtx.fillStyle = 'white';
    newCtx.fillRect(0, 0, newCanvas.width, newCanvas.height);
    
    newCtx.drawImage(canvas, 0, 0);
    
    return newCanvas.toDataURL('image/png');
  };

  handleSubmit = async (e) => {
    try {
      e.preventDefault();
      const errors = this.validateForm();

      if (Object.keys(errors).length === 0) {
        const signatureImage = this.getSignatureImage();
        
        if (!signatureImage) {
          this.setState({ 
            errors: { ...this.state.errors, signature: 'Please provide your signature' } 
          });
          return;
        }

        this.setState(
          (prevState) => ({
            isSubmitting: true,
            formData: {
              ...prevState.formData,
              signature: signatureImage
            }
          }),
        );
        
        this.props.setLoading(true);
        const headers = await getApiHeaderGuest();
        const payload = {
          refIndex: this.state.paramName,
          refId: this.state.paramValue,
          activation_code: this.state.formData?.activation_id,
          signature: signatureImage,
          privacy_agreement: this.state.formData.agreeToPrivacy ? 1 : "",
          terms_agreement: this.state.formData.agreeToTerms ? 1 : "",
          address: this.state.formData.address,
          password: this.state.formData.password,
          c_password: this.state.formData.c_password,
        };
        
        const response = await axios.post(`${SERVER_URL}postpaid/r-s-a-s`, payload, { headers });
        const data = response.data.data;
        
        if (response.status === 200) {
          this.props.setLoading(false);
          this.props.nextStep("payment");
          this.setState({ isSubmitting: false });
        }
      } else {
        this.setState({ errors });
      }
    } catch (error) {
      this.props.setLoading(false);
      this.setState({ isSubmitting: false });
      swal({
        text: error.response.data.message,
        allowOutsideClick: false,
        closeOnClickOutside: false,
        icon: "error"
      });
    }
  };

  // Enhanced signature end handler with data preservation
  handleSignatureEnd = () => {
    if (!this.signatureRef.current.isEmpty()) {
      try {
        // Save the signature stroke data for restoration
        const signatureData = this.signatureRef.current.toData();
        this.setState((prevState) => ({
          hasSignature: true,
          signatureData: signatureData, // Store the signature data
          errors: {
            ...prevState.errors,
            signature: ""
          }
        }));
      } catch (error) {
        console.warn('Failed to save signature data:', error);
        // Fallback - just mark as having signature
        this.setState((prevState) => ({
          hasSignature: true,
          errors: {
            ...prevState.errors,
            signature: ""
          }
        }));
      }
    }
  };

  // Enhanced clear signature with data cleanup
  clearSignature = () => {
    if (this.signatureRef.current) {
      this.signatureRef.current.clear();
    }
    this.setState((prevState) => ({
      hasSignature: false,
      signatureData: null, // Clear stored signature data
      errors: {
        ...prevState.errors,
        signature: ''
      }
    }));
  };

  componentDidUpdate(prevProps) {
    if (prevProps.customer_details !== this.props.customer_details ) {
      const customerAddress = this.props.customer_details?.address;

      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          address: customerAddress 
        }
      }));
    }
  }


  clearAddress = (event) => { 
    this.setState({ addressmask : ''}); 
    this.setState({ address_full: ''}); 
}


clearAddress = (event) => {
  event.preventDefault();
  this.setState(prevState => ({
    formData: {
      ...prevState.formData,
      address: ""
    }
  }));

  // manually clear the input field
  // const input = document.getElementById("address");
  // if (input) input.value = "";
};








  render() {
    const { formData, errors, isSubmitting } = this.state;
    const { payment_details, customer_details, portinDetails, common_data,planMapping} = this.props;



    return (
      <div className="post-paid-common-container">
        <div className="container" style={{ background: 'none' }}>
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-12">
              <div className="card post-paid-common-card">
                <div className="post-paid-common-header">
                  <h1 className="post-paid-common-title"></h1>
                  <img className="postpaid-logo" src={whiteLOgo} alt="Logo" />
                </div>
                <div>
                  <h2 className="post-paid-common-title-second">Telsim Upfront Mobile Plan – Customer Terms & Activation Form</h2>
                </div>
                <div className="post-paid-common-form">
                  <div className="row">
                    
                    {/* Order Details */}
                    <div className="col-lg-7 col-md-12 col-sm-12">
                      <div className="order-details-table">
                        <h3 className="post-paid-common-section-title">Order Details</h3>
                        <table className="table table-striped post-paid-table-data">
                          <tbody>
                            {payment_details?.sim_type && (
                              <tr>
                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Sim Type :</th>
                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {payment_details?.sim_type}</td>
                              </tr>
                            )}
                            
                            {payment_details?.sim_number && (
                              <tr>
                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Sim Number :</th>
                                <td style={{ fontSize: '15px', fontWeight: '500' }}>{payment_details?.sim_number}</td>
                              </tr>
                            )}
                            {payment_details?.activation_type && (
                              <tr>
                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Activation Type :</th>
                                <td style={{ fontSize: '15px', fontWeight: '500' }}> {payment_details?.activation_type}</td>
                              </tr>
                            )}
                            
                            {payment_details?.display_name && (
                              <tr>
                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Plan Name :</th>
                                <td className="post-paid-common-plan-name" style={{ fontSize: "15px", fontWeight: "500" }}>{planMapping?.length > 0 ? <>{planMapping[0].data} <span style={{ textDecoration: "line-through" }}>${planMapping[0].amount}</span> ${planMapping[0].sell_amount} {planMapping[0].description}</> : payment_details?.display_name}</td>
                              </tr>
                            )}
                          {portinDetails && Object.keys(portinDetails)?.length > 0 && (
                              <>
                                {portinDetails.mobile_number && (
                                  <tr>
                                    <th style={{ fontSize: '14px', fontWeight: '600' }}>Mobile Number :</th>
                                    <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.mobile_number}</td>
                                  </tr>
                                )}
                                {portinDetails.mobile_provider && (
                                  <tr>
                                    <th style={{ fontSize: '14px', fontWeight: '600' }}>Mobile Provider :</th>
                                    <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.mobile_provider}</td>
                                  </tr>
                                )}
                                {portinDetails.port_service_type && (
                                  <tr>
                                    <th style={{ fontSize: '14px', fontWeight: '600' }}>Service Type :</th>
                                    <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.port_service_type}</td>
                                  </tr>
                                )}
                                {portinDetails.port_dob && (
                                  <tr>
                                    <th style={{ fontSize: '14px', fontWeight: '600' }}>Date of Birth:</th>
                                    <td style={{ fontSize: '15px', fontWeight: '500' }}> {portinDetails.port_dob}</td>
                                  </tr>
                                )}
                                {portinDetails.port_account_id && (
                                  <tr>
                                    <th style={{ fontSize: '14px', fontWeight: '600' }}>Account ID :</th>
                                    <td style={{ fontSize: '15px', fontWeight: '500' }}>{portinDetails.port_account_id}</td>
                                  </tr>
                                )}
                              </>
                            )}

                            {common_data?.Activation_from === 'TAP' ? (
                              <tr>
                                <th style={{ fontSize: '14px', fontWeight: '600' }}>Payment Status :</th>
                                <td style={{ fontSize: '15px', fontWeight: '500' }}> Paid</td>
                              </tr>
                            ) : (
                              payment_details?.total_amount && (
                                <tr>
                                  <th style={{ fontSize: '14px', fontWeight: '600' }}>Total Amount :</th>
                                  <td style={{ fontSize: '15px', fontWeight: '500' }}> ${payment_details.total_amount}</td>
                                </tr>
                              )
                            )}

                            
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {/* Personal Info */}
                    <div className="col-lg-5 col-md-12 col-sm-12">
                      <div className="personal-info-table">
                        <h3 className="post-paid-common-section-title">Personal Information</h3>
                        <table className="table table-bordered table-post-paid-personal-info" style={{backgroundColor: 'red!important'}}>
                          <tbody>
                            <tr>
                              <th style={{ fontSize: '14px', fontWeight: '600' }}>Full Name :</th>
                              <th style={{ fontSize: '15px', fontWeight: '500' }}>
                                 {
                                  [customer_details?.sal
                                    ? customer_details.sal.slice(0, 1).toUpperCase() + customer_details.sal.slice(1).toLowerCase()
                                    : '', customer_details?.firstName, customer_details?.middleName, customer_details?.surname]
                                    .filter(Boolean)
                                    .join(' ')
                                }
                              </th>
                            </tr>
                            <tr>
                              <th style={{ fontSize: '14px', fontWeight: '600' }}>Email ID :</th>
                              <th style={{ fontSize: '15px', fontWeight: '500' }}> {customer_details?.email}</th> 
                            </tr>
                            {customer_details?.address&&(
                            <tr>
                              <th style={{ fontSize: '14px', fontWeight: '600' }}>Address :</th>
                              <th style={{ fontSize: '15px', fontWeight: '500' }}> {customer_details?.address}</th>
                            </tr>
                            )}

                          </tbody>
                        </table>
                      </div>
                    </div>

                    {customer_details.myaccount_exist && (
                      <>
                        <p className='common-module-note'> Note: {customer_details.myaccount_exist_text} </p>
                      </>
                    )}

                  </div>
                  {/* Consent Section */}
                  <p style={{ fontWeight: '900' }} className="mob-margin">For more details about the plan, please refer to <a href="https://www.telsim.com.au/critical-information-summary/telsim-upfront-mobile-plans" target="_blank" style={{ color: '#d12e7f', textDecoration: 'none' }}>Critical Information Summary</a> </p>
                  <div className="post-paid-common-section">
                    <div className="row">
                      <div className="col-md-12 col-12 mb-3 col-lg-12">
                        <label className="form-label post-paid-common-label">
                          Enter the activation code <span style={{color:"red"}}>* </span>
                        </label>
                        <input
                          type="text"
                          name="activation_id"
                          value={formData.activation_id}
                          onChange={this.handleInputChange}
                          className={`form-control post-paid-common-input ${errors.activation_id ? 'is-invalid' : ''}`}
                          placeholder="Enter your Activation Code"
                          maxLength={10}
                          autocomplete="new-password"
                        />
                        {errors.activation_id && (
                          <div className="post-paid-common-error">{errors.activation_id}</div>
                        )}
                      </div>

                      {!customer_details.myaccount_exist && (
                        <>
                          <div className="col-md-6 col-6 mb-6 col-lg-6 mob-fullwidth">
                            <label className="form-label post-paid-common-label">
                              Create a password to manage Your Telsim My Account<span style={{color:"red"}}>* </span>
                            </label>
                            
                            <input
                              type="password"
                              name="password"
                              value={formData.password}
                              onChange={this.handleInputChange}
                              className={`form-control post-paid-common-input ${errors.password ? 'is-invalid' : ''}`}
                              placeholder="Enter Password for My Account"
                              maxLength={50}
                              autocomplete="new-password"
                            />
                            {errors.password && (
                              <div className="post-paid-common-error">{errors.password}</div>
                            )}
                          </div>

                          <div className="col-md-6 col-6 mb-6 col-lg-6 mob-fullwidth">
                            <label className="form-label post-paid-common-label">
                              Confirm Password
                            </label>
                            
                            <input
                              type="password"
                              name="c_password"
                              value={formData.c_password}
                              onChange={this.handleInputChange}
                              className={`form-control post-paid-common-input ${errors.c_password ? 'is-invalid' : ''}`}
                              placeholder="Confirm Password for My Account"
                              maxLength={50}
                              autocomplete="new-password"
                            />
                            {errors.c_password && (
                              <div className="post-paid-common-error">{errors.c_password}</div>
                            )}
                          </div>
                        </>
                      )}
                      
                    </div>

                    

                    {this.state.formData.address ? (
                      // <div className="col-md-11 col-11 mb-3 `${customer_details.address === null ? "col-11" : "col-lg-12"}`">
                      <div  className={`mb-3 ${customer_details.address === null ? "col-lg-11" : "col-lg-12" }`}>
                      <label className="form-label post-paid-common-label">Enter Your Address Here<span style={{color:"red"}}>* </span></label>
                      <div className="row">
                        {/* <div className="col-11"> */}
                        <div className={`${customer_details.address === null ? "col-lg-11" : "col-12"}`}>

                          <input
                            type="text"
                            name="address"
                            value={this.state.formData.address}
                            className={`form-control post-paid-common-input post-paid-address-input ${errors.address ? 'is-invalid' : ''}`}
                            placeholder="Enter your Address"
                            readOnly
                          />
                        </div>
                        <div className="col-1 d-flex align-items-center justify-content-center">
                          {this.state.formData.address &&  customer_details.address === null &&(
                            <span
                            className="d-none d-lg-block"
                              onClick={this.clearAddress}
                              style={{ cursor: "pointer", fontWeight: "bold", color: "red", fontSize: "20px" }}
                            >
                              ✕
                            </span>
                          )}

                        </div>

                        {this.state.formData.address &&  customer_details.address === null &&(
                            <div className="mb-2 d-block d-lg-none">
                              <button
                                type="button"
                                className="btn btn-md btn-danger mt-2 "
                                onClick={this.clearAddress}
                              >
                                Clear Address
                              </button>
                            </div>
                        )}
                      </div>
                    </div>
                    
                      
                    ) : (
                      customer_details.address === null && (
                        <div className="input-group" id="curr_addr_div">
                          <p>Enter Valid Address Here <span style={{color:"red"}}>* </span> </p>
                          <AddressFinder
                            addressFinderKey="UJCFN4HL6YRMT3D9K8PG"
                            inputClassName={`address ${errors.address ? 'is-invalid' : ''}`}
                            id="address"
                            onChange={this.setaddressFinder}
                          />
                        </div>
                      
                      
                      
                      )
                      )}
                      {errors.address && <div className="post-paid-common-error">{errors.address}</div>}

                    {/* Enhanced Signature Pad */}
                    <div className="mb-3 mt-3">
                      <label className="form-label fw-bold">Digital Signature<span style={{color:"red"}}>* </span></label>
                      <div 
                        className="border rounded signature-container" 
                        style={{ 
                          backgroundColor: '#fff', 
                          width: '100%', 
                          height: '150px',
                          touchAction: 'none',
                          position: 'relative',
                          overflow: 'hidden'
                        }}
                      >
                        <SignatureCanvas
                          ref={this.signatureRef}
                          penColor="black"
                          dotSize={1}
                          minWidth={0.5}
                          maxWidth={2}
                          velocityFilterWeight={0.7}
                          minDistance={5}
                          throttle={16}
                          canvasProps={{
                            className: 'signature-canvas',
                            style: { 
                              backgroundColor: '#fff',
                              width: '100%',
                              height: '150px',
                              border: '1px dashed #ccc',
                              touchAction: 'none',
                              display: 'block'
                            }
                          }}
                          onEnd={this.handleSignatureEnd}
                        />
                      </div>

                      
                      {errors.signature && <div className="post-paid-common-error">{errors.signature}</div>}
                      
                      <div className='mb-2'>
                        <button
                          type="button"
                          className="btn btn-md btn-danger mt-2"
                          onClick={this.clearSignature}
                        >
                          Clear Signature
                        </button>
                      </div>
                    </div>

                     


                    <div className="mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name="agreeToTerms"
                          checked={formData.agreeToTerms}
                          onChange={this.handleInputChange}
                          className="form-check-input post-paid-common-checkbox"
                          id="agreeToTerms"
                        />
                        <label className="form-check-label post-paid-common-checkbox-label" htmlFor="agreeToTerms">
                          I have read and understood <a href="https://www.telsim.com.au/standard-form-of-agreement-sim-only-plans" target="_blank" rel="noopener noreferrer">  Telsim's Standard Form of Agreement</a><span style={{color:"red"}}> *</span>
                        </label>
                      </div>
                      {errors.agreeToTerms && <div className="post-paid-common-error">{errors.agreeToTerms}</div>}
                    </div>

                    <div className="mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          name="agreeToPrivacy"
                          checked={formData.agreeToPrivacy}
                          onChange={this.handleInputChange}
                          className="form-check-input post-paid-common-checkbox"
                          id="agreeToPrivacy"
                        />
                        <label className="form-check-label post-paid-common-checkbox-label" htmlFor="agreeToPrivacy">
                          I have read and understood   <a href="https://www.telsim.com.au/critical-information-summary/telsim-upfront-mobile-plans" target="_blank" rel="noopener noreferrer"> Critical Information Summary</a>  <span style={{color:"red"}}> * </span>
                        </label>
                      </div>
                      {errors.agreeToPrivacy && <div className="post-paid-common-error">{errors.agreeToPrivacy}</div>}
                    </div>

                  </div>

                  <button
                    type="button"
                    disabled={isSubmitting}
                    className="btn post-paid-common-submit-btn"
                    onClick={this.handleSubmit}
                  >
                    {isSubmitting ? (
                      <>
                        <div className="post-paid-common-spinner d-inline-block me-2"></div>
                        Processing...
                      </>
                    ) : (
                      'Next'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Consent;